'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import gsap from 'gsap'
import hoverintent from 'hoverintent'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--home'
        this.$logo = this.view.querySelector('.jsLogo')
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 200);
        // this.hoverSlide()
        if(Env.mobileCSS) {
          const vid = this.view.querySelector('.video-mobile')
          vid.addEventListener('canplay',()=>{
            this.hidePosters()
          })
          vid.play()
        } else {
          const vid = this.view.querySelector('.video-desktop')
          vid.addEventListener('canplay',()=>{
            this.hidePosters()
          })
          vid.play()


        }

    }

    hidePosters()
    {
      for (let poster of this.view.querySelectorAll('.jsPoster')) {
        gsap.set(poster,{ opacity:0})
      }
    }

    hoverSlide()
    {
      const $slide1 = this.view.querySelector('.jsSlide1')
      const $parent1 = $slide1.parentElement
      const $slide2 = this.view.querySelector('.jsSlide2')
      const $parent2 = $slide2.parentElement

      // var opts = {
      //   timeout: 500,
      //   interval: 50
      // };
      // var hoverListener = hoverintent($slide1,
      //   function() {
      //     gsap.fromTo($parent1,{zIndex:3},{ width:'55%', duration:1, ease:'power3.out' })
      //     gsap.fromTo($parent2,{zIndex:2},{ width:'45%', duration:1, ease:'power3.out' })
      //   }, function() {
      //     gsap.to($parent1,{ width:'50%', duration:1, ease:'power3.out' })
      //     gsap.to($parent2,{ width:'50%', duration:1, ease:'power3.out' })
      //   }).options(opts);;

      // var hoverListener2 = hoverintent($slide2,
      //     function() {
      //       gsap.fromTo($parent1,{zIndex:2},{ width:'45%', duration:1, ease:'power3.out' })
      //       gsap.fromTo($parent2,{zIndex:3},{ width:'55%', duration:1, ease:'power3.out' })
      //     }, function() {
      //       gsap.to($parent1,{ width:'50%', duration:1, ease:'power3.out' })
      //       gsap.to($parent2,{ width:'50%', duration:1, ease:'power3.out' })
      //     }).options(opts);;

      let openValue = '57';
      let closeValue = '43';

      $slide1.addEventListener('mouseenter',()=>{
        if(Env.mobileCSS == false) {
          this.$logo.classList.add('slide-left')
          gsap.fromTo($parent1,{zIndex:3},{ width:`${openValue}%`, duration:1, ease:'power3.out'})
          gsap.fromTo($parent2,{zIndex:2},{ width:`${closeValue}%`, duration:1, ease:'power3.out' })
        }

      })
      $slide1.addEventListener('mouseleave',()=>{
        if(Env.mobileCSS == false) {
          this.$logo.classList.remove('slide-left')
          gsap.to($parent1,{ width:'50%', duration:1, ease:'power3.out' })
          gsap.to($parent2,{ width:'50%', duration:1, ease:'power3.out' })
        }
      })
      $slide2.addEventListener('mouseenter',()=>{
        if(Env.mobileCSS == false) {
          this.$logo.classList.add('slide-right')
          gsap.fromTo($parent1,{zIndex:2},{ width:`${closeValue}%`, duration:1, ease:'power3.out' })
          gsap.fromTo($parent2,{zIndex:3},{ width:`${openValue}%`, duration:1, ease:'power3.out' })
        }
      })
      $slide2.addEventListener('mouseleave',()=>{
        if(Env.mobileCSS == false) {
          this.$logo.classList.remove('slide-right')
          gsap.to($parent1,{ width:'50%', duration:1, ease:'power3.out' })
          gsap.to($parent2,{ width:'50%', duration:1, ease:'power3.out' })
        }
      })
    }

    intro()
    {
        console.log('intro');
    }
}

page = Barba.BaseView.extend({
    namespace: 'home',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
